import React, { Component } from "react";
import Uri from "../../Network/Uri";
import getResponseClient from "../../Network/GetClientDataResponse";
import ProfitLoss from "./ProfitLoss";

import {
    MISC,
    GET_VENDOR_INVOICES,
} from "../../Network/ApiPaths";

let clientHost;
let storeFresh;
let storeIdValue;

class ProfitLossContainer extends Component {
    constructor(props) {
        super(props);

        const userCheck = window.localStorage.getItem("access");
        const storeDet = JSON.parse(userCheck);

        if (storeDet !== null) {
            storeIdValue = storeDet.storeId;
        } else {
            storeIdValue = "";
        }

        const client = window.localStorage.getItem("clientAccess");
        storeFresh = JSON.parse(client);

        if (storeFresh !== null) {
            storeIdValue = storeFresh.storeId;
            clientHost = storeFresh.host;
        }

        const currentYear = new Date().getFullYear();
        this.yearList = [];
        for (let year = currentYear; year >= currentYear - 5; year--) {
            this.yearList.push(year);
        }

        this.state = {
            salesData: [],
            invoices: [],

            salesLoaded: false,
            invoicesLoaded: false,

            dailyData: [],

            profitLossChartData: [],
            profitLossYear: new Date().getFullYear(),
            profitLossMonth: "all",

            today: {
                sales: 0,
                expenses: 0,
                profit: 0,
            },
            yesterday: {
                sales: 0,
                expenses: 0,
                profit: 0,
            },
            week: {
                sales: 0,
                expenses: 0,
                profit: 0,
            },
            month: {
                sales: 0,
                expenses: 0,
                profit: 0,
            },
            fromDate: "",
            toDate: "",
            custom: {
                sales: 0,
                expenses: 0,
                profit: 0,
            },
        };
    }
    // ---------------------------------------------------------
    // UPDATE CUSTOM DATE
    // ---------------------------------------------------------

    onFromDateChange = (e) => {
        this.setState({
            fromDate: e.target.value,
        });
    };

    onToDateChange = (e) => {
        this.setState({
            toDate: e.target.value,
        });
    };

    componentDidMount() {
        this.getSales();
        this.getInvoices();
    }

    // ---------------------------------------------------------
    // GET SALES
    // ---------------------------------------------------------

    getSales = () => {
        if (!clientHost || !storeFresh) {
            return;
        }

        const apiPath = new Uri(clientHost + MISC).addQueryParam(
            "store_id",
            storeIdValue
        );

        getResponseClient(
            apiPath,
            storeFresh.key,
            (onSuccessResponse) => {
                const sales = onSuccessResponse.response || [];

                this.setState(
                    {
                        salesData: sales,
                        salesLoaded: true,
                    },
                    this.calculateIfReady
                );
            },
            (onError) => {
                console.log("Sales API Error:", onError);
            }
        );
    };
    // ---------------------------------------------------------
    // ProfitLossChart
    // ---------------------------------------------------------
    onProfitLossYearChange = (e) => {
        this.setState(
            {
                profitLossYear: Number(e.target.value)
            },
            () => {
                this.prepareProfitLossChart();
            }
        );
    };

    onProfitLossMonthChange = (e) => {
        this.setState(
            {
                profitLossMonth: e.target.value
            },
            () => {
                this.prepareProfitLossChart();
            }
        );
    };

    // ---------------------------------------------------------
    // GET VENDOR INVOICES
    // ---------------------------------------------------------

    getInvoices = () => {
        console.log("========== P&L STORE DEBUG ==========");
        console.log("storeFresh:", storeFresh);
        console.log("storeFresh.storeId:", storeFresh?.storeId);
        console.log("storeFresh.key:", storeFresh?.key);
        console.log("clientHost:", clientHost);
        console.log("=====================================");
        const apiPath = new Uri(clientHost + GET_VENDOR_INVOICES)
            .addQueryParam("store_id", storeFresh.storeId);

        console.log("P&L: Getting invoices...");

        getResponseClient(
            apiPath,
            storeFresh.key,
            (onSuccessResponse) => {
                const invoices = onSuccessResponse.result || [];

                this.setState(
                    {
                        invoices: invoices,
                        invoicesLoaded: true,
                    },
                    this.calculateIfReady
                );
            },
            (onError) => {
                console.error("P&L Get Invoices Error:", onError);
            }
        );
    };

    // ---------------------------------------------------------
    // CALCULATE SUMMARY
    // ---------------------------------------------------------

    calculateSummary = () => {
        const { salesData, invoices } = this.state;

        console.log("===== CALCULATING P&L =====");
        console.log("Sales Data:", salesData);
        console.log("Invoice Data:", invoices);

        const getSales = (range) => {
            const item = salesData.find(
                (q) => q.range === range
            );

            if (!item) {
                return 0;
            }

            return Number(item.final_amount || 0);
        };

        const todayDate = new Date();

        const yesterdayDate = new Date();
        yesterdayDate.setDate(
            yesterdayDate.getDate() - 1
        );

        // Start of this week - Monday
        const weekStartDate = new Date();
        const day = weekStartDate.getDay();

        const diff =
            day === 0 ? 6 : day - 1;

        weekStartDate.setDate(
            weekStartDate.getDate() - diff
        );

        // ---------------------------------------------------------
        // SALES
        // ---------------------------------------------------------

        const todaySales = getSales("Today");
        const yesterdaySales = getSales("Yesterday");
        const weekSales = getSales("Last Week");
        const monthSales = getSales("Last Month");

        // ---------------------------------------------------------
        // EXPENSES
        // ---------------------------------------------------------

        // Start of today
        const todayStart = new Date(
            todayDate.getFullYear(),
            todayDate.getMonth(),
            todayDate.getDate()
        );

        // Start of tomorrow
        const tomorrowStart = new Date(
            todayDate.getFullYear(),
            todayDate.getMonth(),
            todayDate.getDate() + 1
        );

        const todayExpenses = invoices.reduce(
            (total, invoice) => {
                const invoiceDate = this.parseInvoiceDate(
                    invoice.invoice_date
                );

                if (!invoiceDate) {
                    return total;
                }

                if (
                    invoiceDate >= todayStart &&
                    invoiceDate < tomorrowStart
                ) {
                    return (
                        total +
                        Number(invoice.invoice_amount || 0)
                    );
                }

                return total;
            },
            0
        );

        // Start of yesterday
        const yesterdayStart = new Date(
            todayDate.getFullYear(),
            todayDate.getMonth(),
            todayDate.getDate() - 1
        );

        const yesterdayExpenses = invoices.reduce(
            (total, invoice) => {
                const invoiceDate = this.parseInvoiceDate(
                    invoice.invoice_date
                );

                if (!invoiceDate) {
                    return total;
                }

                if (
                    invoiceDate >= yesterdayStart &&
                    invoiceDate < todayStart
                ) {
                    return (
                        total +
                        Number(invoice.invoice_amount || 0)
                    );
                }

                return total;
            },
            0
        );

        // Start of current week (Monday)
        const currentWeekStart = new Date(
            todayDate.getFullYear(),
            todayDate.getMonth(),
            todayDate.getDate() - ((todayDate.getDay() + 6) % 7)
        );

        // Start of last week
        const lastWeekStartDate = new Date(
            currentWeekStart.getFullYear(),
            currentWeekStart.getMonth(),
            currentWeekStart.getDate() - 7
        );

        const weekExpenses = invoices.reduce(
            (total, invoice) => {
                const invoiceDate = this.parseInvoiceDate(
                    invoice.invoice_date
                );

                if (!invoiceDate) {
                    return total;
                }

                if (
                    invoiceDate >= lastWeekStartDate &&
                    invoiceDate < currentWeekStart
                ) {
                    return (
                        total +
                        Number(invoice.invoice_amount || 0)
                    );
                }

                return total;
            },
            0
        );

        const currentMonthStart = new Date(
            todayDate.getFullYear(),
            todayDate.getMonth(),
            1
        );

        const lastMonthStartDate = new Date(
            todayDate.getFullYear(),
            todayDate.getMonth() - 1,
            1
        );

        const monthExpenses = invoices.reduce(
            (total, invoice) => {
                const invoiceDate = this.parseInvoiceDate(
                    invoice.invoice_date
                );

                if (!invoiceDate) {
                    return total;
                }

                if (
                    invoiceDate >= lastMonthStartDate &&
                    invoiceDate < currentMonthStart
                ) {
                    return (
                        total +
                        Number(invoice.invoice_amount || 0)
                    );
                }

                return total;
            },
            0
        );

        const result = {
            today: {
                sales: todaySales,
                expenses: todayExpenses,
                profit: todaySales - todayExpenses,
            },

            yesterday: {
                sales: yesterdaySales,
                expenses: yesterdayExpenses,
                profit: yesterdaySales - yesterdayExpenses,
            },

            week: {
                sales: weekSales,
                expenses: weekExpenses,
                profit: weekSales - weekExpenses,
            },

            month: {
                sales: monthSales,
                expenses: monthExpenses,
                profit: monthSales - monthExpenses,
            },
        };

        console.log("===== P&L RESULT =====");
        console.log(result);

        this.setState(result);
    };

    // ---------------------------------------------------------
    // CALCULATE DAILY BREAKDOWN
    // ---------------------------------------------------------

    calculateDailyData = () => {
        const { salesData, invoices } = this.state;

        const dailyMap = {};

        // --------------------------------
        // EXPENSES FROM VENDOR INVOICES
        // --------------------------------

        invoices.forEach((invoice) => {
            const invoiceDate = this.parseInvoiceDate(
                invoice.invoice_date
            );

            if (!invoiceDate) {
                return;
            }

            const date = this.formatDate(invoiceDate);

            if (!dailyMap[date]) {
                dailyMap[date] = {
                    date: date,
                    sales: 0,
                    expenses: 0,
                    profit: 0,
                };
            }

            dailyMap[date].expenses += Number(
                invoice.invoice_amount || 0
            );
        });

        // --------------------------------
        // SALES
        // --------------------------------

        console.log("===== DAILY DATA DEBUG =====");
        console.log("Daily Map:", dailyMap);
        console.log("Sales Data:", salesData);

        const dailyData = Object.values(dailyMap)
            .map((item) => ({
                date: item.date,
                sales: item.sales,
                expenses: item.expenses,
                profit: item.sales - item.expenses,
            }))
            .sort((a, b) =>
                a.date.localeCompare(b.date)
            );

        console.log("Final Daily Data:", dailyData);

        this.setState({
            dailyData: dailyData,
        });
    };

    calculateIfReady = () => {

        if (
            !this.state.salesLoaded ||
            !this.state.invoicesLoaded
        ) {
            return;
        }

        console.log(
            "Both APIs loaded. Calculating P&L..."
        );

        this.calculateSummary();
        this.calculateDailyData();

        // Prepare chart AFTER invoices are loaded
        this.prepareProfitLossChart();
    };

    // ---------------------------------------------------------
    // GET GROSS SALES FROM MISC
    // ---------------------------------------------------------

    getSalesByRange = (range) => {
        const { salesData } = this.state;

        if (!salesData || salesData.length === 0) {
            return 0;
        }

        const result = salesData.filter(
            (item) => item.range === range
        );

        if (result.length === 0) {
            return 0;
        }

        return result.reduce((total, item) => {
            return total + Number(item.final_amount || 0)
        }, 0);
    };

    // ---------------------------------------------------------
    // GET INVOICE EXPENSES
    // ---------------------------------------------------------

    getInvoiceExpenses = (period) => {
        const { invoices } = this.state;

        if (!invoices || invoices.length === 0) {
            return 0;
        }

        const today = new Date();

        const startToday = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate()
        );

        const yesterday = new Date(startToday);
        yesterday.setDate(yesterday.getDate() - 1);

        const startWeek = new Date(startToday);

        // Monday as start of week
        const day = startWeek.getDay();
        const difference = day === 0 ? 6 : day - 1;

        startWeek.setDate(
            startWeek.getDate() - difference
        );

        const startMonth = new Date(
            today.getFullYear(),
            today.getMonth() - 1,
            1
        );

        const endMonth = new Date(
            today.getFullYear(),
            today.getMonth(),
            0
        );

        return invoices.reduce((total, invoice) => {
            const invoiceDate = this.parseInvoiceDate(
                invoice.invoice_date
            );

            if (!invoiceDate) {
                return total;
            }

            let include = false;

            if (period === "today") {
                include =
                    invoiceDate >= startToday &&
                    invoiceDate < this.addDays(startToday, 1);
            }

            if (period === "yesterday") {
                include =
                    invoiceDate >= yesterday &&
                    invoiceDate < startToday;
            }

            if (period === "week") {
                include = invoiceDate >= startWeek;
            }

            if (period === "month") {
                include =
                    invoiceDate >= startMonth &&
                    invoiceDate <= endMonth;
            }

            if (include) {
                return total + Number(
                    invoice.invoice_amount || 0
                );
            }

            return total;
        }, 0);
    };
    // ---------------------------------------------------------
    // PARSE INVOICE DATE
    // ---------------------------------------------------------

    parseInvoiceDate = (dateValue) => {

        if (!dateValue) {
            return null;
        }

        const date = new Date(dateValue);

        if (isNaN(date.getTime())) {
            return null;
        }

        return new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate()
        );
    };

    formatDate = (date) => {

        const year = date.getFullYear();

        const month = String(
            date.getMonth() + 1
        ).padStart(2, "0");

        const day = String(
            date.getDate()
        ).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };


    // ---------------------------------------------------------
    // ADD DAYS
    // ---------------------------------------------------------

    addDays = (date, days) => {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    };

    // ---------------------------------------------------------
    // CUSTOM DATE
    // ---------------------------------------------------------

    onCustomDateChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    applyCustomDate = () => {
        const {
            fromDate,
            toDate,
            salesData,
            invoices,
        } = this.state;

        if (!fromDate || !toDate) {
            alert("Please select From Date and To Date");
            return;
        }

        if (fromDate > toDate) {
            alert("From Date cannot be greater than To Date");
            return;
        }

        const result = [];

        const start = new Date(fromDate);
        const end = new Date(toDate);

        for (
            let date = new Date(start);
            date <= end;
            date.setDate(date.getDate() + 1)
        ) {
            const currentDate = this.formatDate(date);

            const daySales = this.getCustomDaySales(
                salesData,
                currentDate
            );

            const dayExpenses = this.getCustomDayExpenses(
                invoices,
                currentDate
            );

            result.push({
                date: currentDate,
                grossSales: daySales,
                expenses: dayExpenses,
                profit: daySales - dayExpenses,
            });
        }

        this.setState({
            customData: result,
        });
    };

    onApplyCustomDate = () => {
        const {
            fromDate,
            toDate,
            invoices
        } = this.state;

        if (!fromDate || !toDate) {
            alert("Please select both From Date and To Date.");
            return;
        }

        if (fromDate > toDate) {
            alert("From Date cannot be greater than To Date.");
            return;
        }

        // ============================================
        // CALCULATE EXPENSES FROM VENDOR INVOICES
        // ============================================

        const customExpenses = invoices.reduce(
            (total, invoice) => {

                const invoiceDate = this.parseInvoiceDate(
                    invoice.invoice_date
                );

                if (!invoiceDate) {
                    return total;
                }

                const formattedDate =
                    this.formatDate(invoiceDate);

                if (
                    formattedDate >= fromDate &&
                    formattedDate <= toDate
                ) {
                    return (
                        total +
                        Number(invoice.invoice_amount || 0)
                    );
                }

                return total;
            },
            0
        );

        console.log("=================================");
        console.log("CUSTOM DATE P&L");
        console.log("From Date:", fromDate);
        console.log("To Date:", toDate);
        console.log("Custom Expenses:", customExpenses);
        console.log("=================================");

        // ============================================
        // GET SALES FROM getSalesData API
        // ============================================

        this.getCustomSales(
            fromDate,
            toDate,
            (customSales) => {

                console.log(
                    "CUSTOM SALES RECEIVED:",
                    customSales
                );

                const profit =
                    customSales - customExpenses;

                console.log(
                    "CUSTOM PROFIT:",
                    profit
                );

                // ====================================
                // UPDATE CUSTOM DATE CARD
                // ====================================

                this.setState({
                    custom: {
                        sales: customSales,
                        expenses: customExpenses,
                        profit: profit
                    }
                });
            }
        );
    };

    getCustomSales = (fromDate, toDate, callback) => {

        if (!clientHost || !storeFresh) {
            console.error("Client host or store information missing.");
            callback(0);
            return;
        }

        const apiPath = new Uri(
            clientHost + "Report/getSalesData/"
        )
            .addQueryParam(
                "storeId",
                storeIdValue
            )
            .addQueryParam(
                "startDate",
                fromDate
            )
            .addQueryParam(
                "endDate",
                toDate
            );

        console.log("=================================");
        console.log("CUSTOM SALES API");
        console.log("Store ID:", storeIdValue);
        console.log("From Date:", fromDate);
        console.log("To Date:", toDate);
        console.log("API:", apiPath);
        console.log("=================================");

        getResponseClient(
            apiPath,
            storeFresh.key,

            (onSuccessResponse) => {

                console.log(
                    "================================="
                );
                console.log(
                    "CUSTOM SALES API RESPONSE"
                );
                console.log(
                    onSuccessResponse
                );
                console.log(
                    "================================="
                );

                // Your API response:
                //
                // {
                //   status: true,
                //   response: {
                //      all: {
                //         NetSale: "655881.249999999"
                //      }
                //   }
                // }

                const response =
                    onSuccessResponse &&
                        onSuccessResponse.response
                        ? onSuccessResponse.response
                        : {};

                console.log("CUSTOM SALES ALL RESPONSE:", response.all);

                const grossAmount =
                    response.all &&
                        response.all.GrossAmount !== undefined
                        ? response.all.GrossAmount
                        : 0;

                const sales =
                    Number(grossAmount) || 0;

                console.log(
                    "CUSTOM GROSS SALES:",
                    sales
                );

                callback(sales);
            },

            (onError) => {

                console.error(
                    "CUSTOM SALES API ERROR:",
                    onError
                );

                callback(0);
            }
        );
    };

    // ---------------------------------------------------------
    // GET SALES FOR ONE DAY
    // ---------------------------------------------------------

    getDailySales = (date, callback) => {

        if (!clientHost || !storeFresh) {
            callback(0);
            return;
        }

        const apiPath = new Uri(
            clientHost + "Report/getSalesData/"
        )
            .addQueryParam("storeId", storeIdValue)
            .addQueryParam("startDate", date)
            .addQueryParam("endDate", date);

        getResponseClient(
            apiPath,
            storeFresh.key,
            (onSuccessResponse) => {

                const response =
                    onSuccessResponse.response || {};

                const sales =
                    Number(
                        response.all?.GrossAmount || 0
                    );

                callback(sales);
            },
            (onError) => {

                console.error(
                    "Daily Sales API Error:",
                    onError
                );

                callback(0);
            }
        );
    };

    // ---------------------------------------------------------
    // PREPARE PROFIT & LOSS CHART
    // ---------------------------------------------------------

    prepareProfitLossChart = () => {

        const {
            profitLossYear,
            profitLossMonth,
            invoices
        } = this.state;

        let startDate;
        let endDate;

        // =====================================================
        // ALL MONTHS
        // =====================================================

        if (profitLossMonth === "all") {

            startDate = new Date(
                profitLossYear,
                0,
                1
            );

            endDate = new Date(
                profitLossYear,
                11,
                31
            );

        }

        // =====================================================
        // SELECTED MONTH
        // =====================================================

        else {

            const month = Number(profitLossMonth);

            startDate = new Date(
                profitLossYear,
                month,
                1
            );

            endDate = new Date(
                profitLossYear,
                month + 1,
                0
            );
        }

        // =====================================================
        // CREATE DATE LIST
        // =====================================================

        const dates = [];

        for (
            let date = new Date(startDate);
            date <= endDate;
            date.setDate(date.getDate() + 1)
        ) {

            dates.push(
                new Date(date)
            );
        }

        // =====================================================
        // GET SALES FOR EACH DATE
        // =====================================================

        Promise.all(

            dates.map((date) => {

                const apiDate =
                    this.formatDate(date);

                return new Promise((resolve) => {

                    this.getDailySales(
                        apiDate,
                        (sales) => {

                            // -----------------------------
                            // EXPENSES FOR THIS DATE
                            // -----------------------------

                            const expenses =
                                invoices
                                    .filter((invoice) => {

                                        const invoiceDate =
                                            this.parseInvoiceDate(
                                                invoice.invoice_date
                                            );

                                        if (!invoiceDate) {
                                            return false;
                                        }

                                        return (
                                            this.formatDate(
                                                invoiceDate
                                            ) === apiDate
                                        );
                                    })
                                    .reduce(
                                        (
                                            total,
                                            invoice
                                        ) => {

                                            return (
                                                total +
                                                Number(
                                                    invoice.invoice_amount ||
                                                    0
                                                )
                                            );

                                        },
                                        0
                                    );

                            // -----------------------------
                            // PROFIT / LOSS
                            // -----------------------------

                            const profitLoss =
                                sales - expenses;

                            // -----------------------------
                            // CHART LABEL
                            // -----------------------------

                            let label;

                            if (
                                profitLossMonth === "all"
                            ) {

                                label =
                                    date.toLocaleString(
                                        "en-US",
                                        {
                                            month: "short"
                                        }
                                    );

                            } else {

                                label =
                                    String(
                                        date.getDate()
                                    ).padStart(2, "0")
                                    +
                                    "-"
                                    +
                                    String(
                                        date.getMonth() + 1
                                    ).padStart(2, "0")
                                    +
                                    "-"
                                    +
                                    date.getFullYear();
                            }

                            resolve({
                                label: label,
                                grossSales: sales,
                                expenses: expenses,
                                profitLoss: profitLoss
                            });
                        }
                    );
                });
            })

        ).then((chartData) => {

            // =================================================
            // ALL MONTHS
            // =================================================

            if (profitLossMonth === "all") {

                // Combine daily data into monthly data

                const monthlyMap = {};

                chartData.forEach((item, index) => {

                    const date = dates[index];

                    const month =
                        date.getMonth();

                    if (!monthlyMap[month]) {

                        monthlyMap[month] = {
                            label:
                                date.toLocaleString(
                                    "en-US",
                                    {
                                        month: "long"
                                    }
                                ),
                            grossSales: 0,
                            expenses: 0,
                            profitLoss: 0
                        };
                    }

                    monthlyMap[month].grossSales +=
                        item.grossSales;

                    monthlyMap[month].expenses +=
                        item.expenses;

                    monthlyMap[month].profitLoss +=
                        item.profitLoss;
                });

                const monthlyData =
                    Object.keys(monthlyMap)
                        .sort(
                            (a, b) =>
                                Number(a) - Number(b)
                        )
                        .map(
                            (month) =>
                                monthlyMap[month]
                        );

                this.setState({
                    profitLossChartData:
                        monthlyData
                });

                console.log(
                    "===== MONTHLY P&L CHART DATA ====="
                );

                console.log(monthlyData);

                return;
            }

            // =================================================
            // SELECTED MONTH
            // =================================================

            chartData.sort((a, b) => {

                const dayA =
                    Number(
                        a.label.split("-")[0]
                    );

                const dayB =
                    Number(
                        b.label.split("-")[0]
                    );

                return dayA - dayB;
            });

            this.setState({
                profitLossChartData:
                    chartData
            });

            console.log(
                "===== DAILY P&L CHART DATA ====="
            );

            console.log(chartData);
        });
    };

    // ---------------------------------------------------------
    // CUSTOM DAY EXPENSES
    // ---------------------------------------------------------

    getCustomDayExpenses = (invoices, date) => {
        return invoices.reduce((total, invoice) => {
            const invoiceDate = this.parseInvoiceDate(
                invoice.invoice_date
            );

            if (!invoiceDate) {
                return total;
            }

            const formattedInvoiceDate =
                this.formatDate(invoiceDate);

            if (formattedInvoiceDate === date) {
                return total + Number(
                    invoice.invoice_amount || 0
                );
            }

            return total;
        }, 0);
    };

    // ---------------------------------------------------------
    // FORMAT DATE
    // ---------------------------------------------------------

    formatDate = (date) => {
        const year = date.getFullYear();

        const month = String(
            date.getMonth() + 1
        ).padStart(2, "0");

        const day = String(
            date.getDate()
        ).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };

    // ---------------------------------------------------------
    // RENDER
    // ---------------------------------------------------------

    render() {
        return (
            <ProfitLoss
                today={this.state.today}
                yesterday={this.state.yesterday}
                week={this.state.week}
                month={this.state.month}
                dailyData={this.state.dailyData}
                fromDate={this.state.fromDate}
                toDate={this.state.toDate}
                custom={this.state.custom}
                onFromDateChange={this.onFromDateChange}
                onToDateChange={this.onToDateChange}
                onApplyCustomDate={this.onApplyCustomDate}
                profitLossYear={this.state.profitLossYear}
                profitLossMonth={this.state.profitLossMonth}
                profitLossChartData={this.state.profitLossChartData}
                yearList={this.yearList}
                onProfitLossYearChange={this.onProfitLossYearChange}
                onProfitLossMonthChange={this.onProfitLossMonthChange}
            />
        );
    }
}

export default ProfitLossContainer;
